module.exports = __webpack_public_path__ + "img/安徽排球学院@2x.46b60649.png";